module.exports = __webpack_public_path__ + "static/media/Rainstorm.cb5e396b.ogg";